// extracted by mini-css-extract-plugin
export default {"oauth-screen":"OAuthScreen__oauth-screen__qY3Hq","oauthScreen":"OAuthScreen__oauth-screen__qY3Hq"};